var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-img',{staticClass:"my-3",attrs:{"src":require('../assets/mona_logo.png'),"contain":"","width":"40px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }